import { Component } from '@angular/core';
import { CommonService } from './common.function';
import { Storage } from '@ionic/storage-angular';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages;
  public labels = [
    'Add Property',
    'Add Tenant',
    'Upcoming Invoice',
    'Tenant Documents',
    'Terms of Use',
    'Settings',
  ];
  user: any;
  login_email: any;
  constructor(
    public config: CommonService,
    private storage: Storage,
) {}
  userLogin = true;
  async ngOnInit() {
    await this.storage.create(); // Ensure storage is initialized
    let user = await this.storage.get('user'); // Properly retrieve user data

    var UserLoginRole = null;
    console.log(this.config.storageGet('user'))
    user =  JSON.parse(
      this.config.storageGet('user')['__zone_symbol__value']
    );

    if(user){
      this.user = user.name;
      this.login_email = user.email;
      UserLoginRole = user.role;
    }
    console.log(this.user);


    if (UserLoginRole == null) {
      this.appPages = [
        { title: 'Login', url: '/login', icon: 'paper-plane' },
        { title: 'Signup', url: '/signup', icon: 'heart' },
        { title: 'Contact Us', url: '/contacts', icon: 'heart' },
      ];
      this.config.appPages = this.appPages;
    }

    if (UserLoginRole == '0') {
      this.appPages = [
        {
          title: 'Dashboard',
          url: '/',
          img: '/assets/menu-icon/dashboard.svg',
        },
        {
          title: 'Properties',
          url: '/properties',
          img: '/assets/menu-icon/property.svg',
        },
        {
          title: 'Tenants',
          url: '/tenants',
          img: '/assets/menu-icon/tenants.svg',
        },
        {
          title: 'Lease',
          url: '/lease',
          img: '/assets/menu-icon/lease.svg',
        },
        {
          title: 'Invoices',
          url: '/invoices',
          img: '/assets/menu-icon/invoice.svg',
        },
        {
          title: 'Expenses',
          url: '/expenses',
          img: '/assets/menu-icon/property.svg',
        },
        {
          title: 'Maintenance',
          url: '/maintenance',
          img: '/assets/menu-icon/maintenance.svg',
        },
        {
          title: 'Rent Collection',
          url: '/auto-rent',
          img: '/assets/menu-icon/rent-collection.svg',
        },
        {
          title: 'Payments',
          url: '/payments',
          img: '/assets/menu-icon/payment.svg',
        },
        {
          title: 'Tasks',
          url: '/tasks',
          img: '/assets/menu-icon/tasks.svg',
        },
        {
          title: 'Reminders',
          url: '/reminders',
          img: '/assets/menu-icon/reminder.svg',
        },
        {
          title: 'Tenant Requests',
          url: '/tenant-requests',
          img: '/assets/menu-icon/property.svg',
        },
        {
          title: 'Templates',
          url: '/templates',
          img: '/assets/menu-icon/templates.svg',
        },
        {
          title: 'Help & FAQs',
          url: '/help-faq',
          img: '/assets/menu-icon/helpf&q.svg',
        },
      ];
      this.config.appPages = this.appPages;
    }

    if (UserLoginRole == '1') {
      this.appPages = [
        { title: 'Home', url: '/home', img: '/assets/menu-icon/property.svg' },

        { title: 'Map', url: '/map', img: '/assets/menu-icon/property.svg' },
        {
          title: 'Wislist',
          url: '/wishlist',
          img: '/assets/menu-icon/wishlist.svg',
        },
        {
          title: 'Requests',
          url: '/requests',
          img: '/assets/menu-icon/requests.svg',
        },
        {
          title: 'Reminders',
          url: '/reminders',
          img: '/assets/menu-icon/reminder.svg',
        },
        {
          title: 'Submitted Applications',
          url: '/submitted-applications',
          img: '/assets/menu-icon/submitted-applications.svg',
        },
      ];

      this.config.appPages = this.appPages;
    }

    if (UserLoginRole == '2') {
      this.appPages = [
        {
          title: 'Add Task',
          url: '/add-task',
          img: '/assets/menu-icon/property.svg',
        },
      ];

      this.config.appPages = this.appPages;
    }
  }

  labelClk(lb) {
    if (lb == 'Add Tenant') {
      this.config.navigateurlname = 'addnewtenant';
      this.config.navigate('tenants');
    }

    if (lb == 'Add Property') {
      this.config.navigateurlname = 'addproperty';
      this.config.navigate('properties');
    }
  }
  logout() {
    this.config.storageRemoveItem('User_loggedIn');
    this.config.storageRemoveItem('token');
    this.config.storageRemoveItem('user');
    this.appPages = [
      { title: 'Login', url: '/login', icon: 'paper-plane' },
      { title: 'Signup', url: '/signup', icon: 'heart' },
      { title: 'Contact Us', url: '/contacts', icon: 'heart' },
    ];
    this.config.appPages = this.appPages;
   // Navigate to login and reload
    this.config.navigate('login');
    setTimeout(() => {
    window.location.reload(); // Reload after navigation
  }, 100);
  }

  async openProfile() {
    this.config.navigate('profile');
  }
}
